module.exports = __webpack_public_path__ + "static/media/certificate-2017.4952eb91.jpeg";